export default {
  MESSAGING_PLUS_ADD_ON_SHOW: 'messaging:plus-add-on:show',
  MESSAGING_PLUS_ADD_ON_LOADED: 'messaging:plus-add-on:loaded',
};
